import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PresentationEnum } from 'src/app/shared/enum/prescription.enum';
import { VerifyStorageService } from 'src/app/shared/services/API/pharmacy/verify-storage.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { LocationModel } from 'src/app/shared/services/models/pharmacy/location.model';
import { MedicinePresentationTypeModel } from 'src/app/shared/services/models/pharmacy/medicine-presentation-type.model';
import { StorageStruct } from 'src/app/shared/services/structs/pharmacy/storage.struct';
import { MedicineBarCodeModalComponent } from 'src/app/shared/components/medicine-bar-code-modal/medicine-bar-code-modal.component';
import { PresentationTypeConfirmModalComponent } from 'src/app/shared/components/presentation-type-confirm-modal/presentation-type-confirm-modal.component';
import { EpisodeStruct } from 'src/app/shared/services/structs/medical-record/episode.struct';
import { MedicinePresentationTypeService } from 'src/app/shared/services/API/pharmacy/medicine-presentation-type.service';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { LiberatePrescriptionRequest } from 'src/app/shared/services/requests/orchestrator-patient/liberate-prescription.request';
import { AlertModalComponent } from 'src/app/shared/components/alert-modal/alert-modal.component';
import { estoqueValidator } from 'src/app/shared/custom-validators/storage.validator';
import { PrescriptionSolutionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-medicine.struct';
import { PrescriptionSolutionNonDispensationModalComponent } from './prescription-solution-non-dispensation-modal/prescription-solution-non-dispensation-modal.component';
import { PharmacyLookupService } from 'src/app/shared/services/API/pharmacy/pharmacy-lookup.service';
import { LookupsBooleanChoiceRequest } from 'src/app/shared/services/requests/pharmacy/lookups-boolean-choice.request';
import { DoseToAdministered } from 'src/app/shared/services/models/pharmacy/dose-to-administered.model';

@Component({
    selector: 'app-release-prescription-solution-modal',
    templateUrl: './release-prescription-solution-modal.component.html',
    styleUrls: ['./release-prescription-solution-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReleasePrescriptionSolutionModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ReleasePrescriptionSolutionModalComponent>,
    public verifyStorageService: VerifyStorageService,
    public medicinePresentationTypeService: MedicinePresentationTypeService,
    private alertService: AlertService,
    private lookupService: PharmacyLookupService,
    private formBuilder: FormBuilder) {
    this.matDialogRef.disableClose = true;
  }

  public model: FormGroup;

  public listLocation: LocationModel[];
  public listStorage: StorageStruct[];
  public presentationList: MedicinePresentationTypeModel[];
  public storage: StorageStruct = new StorageStruct;
  public episode: EpisodeStruct = new EpisodeStruct();
  public prescription: PrescriptionSolutionMedicineStruct = new PrescriptionSolutionMedicineStruct();

  public presentationOthersEnum: PresentationEnum = PresentationEnum.outros.valueOf();
  public idMedicinePresentationType: number;
  public barcodeValue: number;
  public quantityReleased: number;
  public amountRemaining: number = null;
  public idPresentation: number = null;

  public medicinePresentationOther: string = null;
  public quantityDoctor: string;
  public presentationTypeDoctor: string;
  public presentationName: string;
  public dilutionName: string;
  public administrationTypeName: string;

  public haveListItem: boolean = false;
  public isInvalid: boolean = false;
  public isValid: boolean = false;
  public isLoading: boolean = false;
  public validated: boolean = false;
  public patientHasAllergy: boolean = false;
  public listDoseToAdministered: DoseToAdministered[] = [];
  public isObservation: boolean = false;
  public idSector: number;
  public idUserPharmacy: number;

  ngOnInit(): void {
    this.populatePharmacyLookups();

    if (this.data.isObservation) {
      this.isObservation = true;
      this.idSector = this.data.idSector;
    }

    this.listLocation = this.data.listLocation;
    if (this.data.episode)
      this.episode = this.data.episode;
    this.model = this.formBuilder.group({
      idLocation: [, [Validators.required]],
      quantity: ['', [Validators.required, Validators.min(0.001)]],
      idPresentationType: [{ value: '', disabled: true }],
      calculatedTotalQuantity: [{ value: this.prescription.prescriptionSolutionMedicine?.calculatedTotalQuantity, disabled: true }],
      idDoseToAdministered: [{ value: this.prescription.prescriptionSolutionMedicine?.idDoseToAdministered, disabled: true }],
    });

    if (this.isObservation) {
      const location = this.listLocation.find(x => x.idSector === this.idSector);
      this.model.get('idLocation')?.setValue(location?.idLocation);
      this.model.get('idLocation')?.disable();
    }

    this.prescription = this.data.prescription;
    this.patientHasAllergy = this.data.patientHasAllergy;
    this.idPresentation = this.data.idPresentation;
    this.presentationName = this.data.presentationName;
    this.dilutionName = this.data.dilutionName;
    this.administrationTypeName = this.data.administrationTypeName;

    this.quantityDoctor = this.prescription.prescriptionSolutionMedicine.quantity ? this.prescription.prescriptionSolutionMedicine.quantity.toString() : "Não informado";
    this.quantityReleased = this.prescription.quantityReleased ? this.prescription.quantityReleased : 0;

    let quantityForPrescription = null;
    let calculatedQty = this.prescription.calculatedDispensationQuantity;

    if (calculatedQty && this.prescription.quantityReleased)
      quantityForPrescription = calculatedQty - this.prescription.quantityReleased;
    else if (calculatedQty)
      quantityForPrescription = calculatedQty;

    if (this.prescription.idLocation) {
      this.amountRemaining = this.prescription.amountRemaining;
      this.validated = true;

      this.model.get('idLocation')?.setValue(this.prescription.idLocation);
      this.model.get('idPresentationType')?.setValue(this.prescription.idPresentationType);
      this.model.get('idLocation')?.disable();
      this.model.get('quantity')?.setValue(this.prescription.quantityReleased ? this.prescription.quantityReleased.toString() : '');
      this.model.get('quantity')?.setValidators([Validators.required, Validators.min(0.001), Validators.max(this.amountRemaining)]);
      this.model.get('quantity')?.updateValueAndValidity();
    }
    else if (this.prescription.prescriptionSolutionMedicine.idPrescriptionStatus == PrescriptionStatusEnum.NaoDispensado)
      this.model.reset();
    else
      this.model.get('quantity')?.setValue(quantityForPrescription ? quantityForPrescription.toString() : '');

    this.storageSuggestion();
  }

  storageSuggestion() {
    this.verifyStorageService.listMedicineStorage(this.prescription.prescriptionSolutionMedicine.idMedicine, null, this.idSector).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        if (response.listStorage) {
          this.listStorage = response.listStorage;
          this.storage = this.listStorage[0];
          this.isValid = true;
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  openPrescriptionNonDispensationModalFromModal() {
    const dialogRef = this.dialog.open(PrescriptionSolutionNonDispensationModalComponent, {
      data: {
        prescription: this.prescription,
        patientName: this.episode.patientName,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.notDispensed)
          this.notDispensation(result.nonDispensationRequest)
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  clickCancel() {
    this.matDialogRef.close({ cancel: true });
  }

  notDispensation(nonDispensationRequest) {
    this.matDialogRef.close({ nonDispensation: true, nonDispensationRequest: nonDispensationRequest });
  }

  submit() {
    if (!this.patientHasAllergy) {
      this.liberatePrescription();
    }
    else {
      const dialogRef = this.dialog.open(AlertModalComponent, {
        data: {
          hasImage: true,
          isTwoButtonsModal: true,
          title: 'Atenção!',
          description: `O paciente é alérgico a um dos princípios ativos deste medicamento. \nDeseja prosseguir com a liberação?`
        },
      });
      dialogRef.afterClosed().subscribe({
        next: result => {
          if (result && result.confirm) {
            this.liberatePrescription();
          }
          this.isLoading = false;
        }
      });
    }

  }

  liberatePrescription() {
    this.model.get('idLocation')?.markAsTouched();
    this.model.get('quantity')?.markAsTouched();

    if (this.isLoading || this.model.invalid)
      return;
    this.isLoading = true;

    let liberatePrescriptionRequest: LiberatePrescriptionRequest = new LiberatePrescriptionRequest();

    liberatePrescriptionRequest.idStorage = this.barcodeValue;
    liberatePrescriptionRequest.idMedicine = this.prescription.prescriptionSolutionMedicine.idMedicine;
    liberatePrescriptionRequest.quantity = this.model.get('quantity')?.value ? parseFloat(this.model.get('quantity')?.value.replace(",", ".")) : null;
    liberatePrescriptionRequest.idLocation = this.model.get('idLocation')?.value;
    liberatePrescriptionRequest.idPresentationType = this.model.get('idPresentationType')?.value;
    liberatePrescriptionRequest.dilutionName = this.dilutionName;
    liberatePrescriptionRequest.medicineName = this.prescription.medicineName;
    liberatePrescriptionRequest.administrationTypeName = this.administrationTypeName;
    liberatePrescriptionRequest.patientName = this.episode.patientName;
    liberatePrescriptionRequest.motherName = this.episode.motherName;
    liberatePrescriptionRequest.birthDate = this.episode.birthDate;
    liberatePrescriptionRequest.idEpisode = this.episode.idEpisode;
    liberatePrescriptionRequest.idPrescriptionSolutionMedicine = this.prescription.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine;
    liberatePrescriptionRequest.amountRemaining = this.amountRemaining;
    liberatePrescriptionRequest.idUserPharmacy = this.idUserPharmacy;
    liberatePrescriptionRequest.idSector = this.idSector;

    liberatePrescriptionRequest.idStatusPrescription = PrescriptionStatusEnum.Liberado;

    this.isLoading = false;
    this.matDialogRef.close({ liberatePrescriptionRequest: liberatePrescriptionRequest, liberate: true });
  }

  openBarCodeModal() {
    const dialogRef = this.dialog.open(MedicineBarCodeModalComponent, {
      data: {
        idMedicine: this.prescription.prescriptionSolutionMedicine.idMedicine,
        listStorage: this.listStorage,
        amountRemaining: this.amountRemaining,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.barcodeValue) {
          this.barcodeValue = result.barcodeValue;
          this.amountRemaining = result.amountRemaining;
          this.medicinePresentationOther = result.medicine.medicinePresentationOther;
          this.idMedicinePresentationType = result.medicine.idMedicinePresentationType;
          this.model.get('idPresentationType')?.setValue(result.medicine.idMedicinePresentationType);
          if (result.amountRemaining === 0) {
            this.model.get('quantity')?.setValidators([Validators.required, Validators.min(0.001), estoqueValidator(result.amountRemaining)]);
            this.model.get('quantity')?.markAsTouched();
            this.validated = false;
          }
          else {
            this.model.get('quantity')?.setValidators([Validators.required, Validators.min(0.001), Validators.max(result.amountRemaining)]);
            this.validated = true;
          }

          this.model.get('quantity')?.updateValueAndValidity();
          if (!this.isObservation) {
            this.model.get('idLocation')?.setValue(result.idLocation);
            this.model.get('idLocation')?.disable();
          }
          else {
            this.idUserPharmacy = result.idUserMove;
          }
          if (this.idPresentation && this.idMedicinePresentationType != this.idPresentation)
            this.openConfirmModal();
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openConfirmModal() {
    const dialogRef = this.dialog.open(PresentationTypeConfirmModalComponent);

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm == false)
          this.openBarCodeModal();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  populatePharmacyLookups() {
    let request = new LookupsBooleanChoiceRequest();
    request.isToGetMedicineGroupTypeLookup = false;
    request.isToGetMedicineSubgroupLookup = false;
    request.isToGetMedicinePresentationTypeLookup = true;
    request.isToGetMedicineAdministrationTypeLookup = false;
    request.isToGetKitMultiselectLookup = false;
    request.isToGetMeasurementUnitLookup = false;
    request.isToGetDoseToAdministered = true;

    this.lookupService.searchLookupsUsingBooleanRequestFilter(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.presentationList = [];
        if (response.listMedicinePresentationType && response.listMedicinePresentationType.length > 0) {
          this.presentationList = [...response.listMedicinePresentationType];
          this.presentationTypeDoctor = this.idPresentation ? this.presentationName : "Não informado";
        }

        if (response?.listDoseToAdministered?.length > 0)
          this.listDoseToAdministered = [...response.listDoseToAdministered];
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  get doseToAdministeredName(): string {
    const idDose = this.model?.get('idDoseToAdministered')?.value;
    if (!idDose || !this.listDoseToAdministered) return '';
    const doseItem = this.listDoseToAdministered.find(x => x.idDoseToAdministered === idDose);
    return doseItem ? doseItem.name : '';
  }
}